import { FC } from 'react';

import { HELP_PAGE_RECOMMENDATIONS_URL } from 'utils/constants/app';

import { VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { Banner } from 'components/common/MagritteBannerPreviewSidebar/Banner/Banner';
import bannerCourier from 'components/common/MagritteBannerPreviewSidebar/BannerExamplesSection/images/bannerCourier.png';
import bannerWebDev from 'components/common/MagritteBannerPreviewSidebar/BannerExamplesSection/images/bannerWebDev.png';
import { HelpPageLink } from 'components/common/MagritteBannerPreviewSidebar/HelpPageLink/HelpPage';
import { SectionHeader } from 'components/common/MagritteBannerPreviewSidebar/SectionHeader/SectionHeader';

const TrlKeys = {
    title: 'AdCreate.AdForm.BannerExamples.title',
    subtitle: 'AdCreate.AdForm.BannerExamples.subtitle',
    link: 'AdCreate.AdForm.BannerExamples.link',
    banners: {
        first: {
            title: 'AdCreate.Preview.First.title',
            text: 'AdCreate.Preview.First.text',
        },
        second: {
            title: 'AdCreate.Preview.Second.title',
            text: 'AdCreate.Preview.Second.text',
        },
    },
};

export const BannerExamplesSection: FC = () => {
    const trls = useTrls();

    return (
        <VSpacingContainer default={20}>
            <SectionHeader title={trls(TrlKeys.title)} subtitle={trls(TrlKeys.subtitle)} />
            <Banner
                image={bannerCourier}
                title={trls(TrlKeys.banners.first.title)}
                text={trls(TrlKeys.banners.first.text)}
            />
            <Banner
                image={bannerWebDev}
                title={trls(TrlKeys.banners.second.title)}
                text={trls(TrlKeys.banners.second.text)}
            />
            <HelpPageLink url={HELP_PAGE_RECOMMENDATIONS_URL} text={trls(TrlKeys.link)} />
        </VSpacingContainer>
    );
};
